import { createAction } from 'redux-actions';

import * as types from 'constants/propositionPage';

export const load = createAction(types.LOAD, (id) => ({ id }));

export const fetchPropositionSuccess = createAction(types.FETCH_PROPOSITION_SUCCESS, (data): any => data);
export const fetchPropositionFailure = createAction(types.FETCH_PROPOSITION_FAILURE, (error): any => ({ error }));
